import {getVehicleIndex, primaryVehicleCarousel, setCarouselVehicleCode, setIsAngleChanged, swapCompareImages} from "../../slices/vehicleSlice";
import Carousel from 'react-bootstrap/Carousel';
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import Loader from "../Loader/Loader";
import {checkLockStatus} from "../compare/compare.method";
import PowerTrainType from "../Button/PowerTrainType";

export const getVehicleDetails = (vehicle, id) => {
    if (id === 0) {
        return (vehicle.year + " " + vehicle.make + " " + vehicle.model + " " + vehicle.trim)
    }
    return vehicle ? (vehicle.year + " " + vehicle.make + " " + vehicle.model + " " + vehicle.trim) : null
}

export const changeHandler = async (id, vehicle, setButtonClicked, setCurretntVehicleID, setVehicleData, dispatch, setOpenModal) => {

    setButtonClicked(true)
    setCurretntVehicleID(id);
    await setVehicleData(vehicle)
    dispatch(getVehicleIndex(id));
    await setOpenModal(true);
};

export const handleModalClose = (setOpenModal) => {
    setOpenModal(false)
}

export const initiateSwapCompetitor = (id, dispatch) => {
    dispatch(swapCompareImages({ secondIndex: id, swapTriggered: true }));
}

export const handleCarouselSelect = (eventKey, vehicle, vehicleCode, props, trackGalleryScrollRight, trackGalleryScrollLeft, dispatch) => {
    const totalImages = Object.values(vehicle.media[Object.keys(vehicle.media)[0]]).length;
    if (eventKey > totalImages - 1) {
        eventKey = totalImages - 1;
    }

    if (eventKey > vehicleCode) {
        props && trackGalleryScrollRight(props);
    } else if (eventKey < vehicleCode) {
        props && trackGalleryScrollLeft(props);
    }
    dispatch(setIsAngleChanged(false));
    dispatch(primaryVehicleCarousel(false));
    dispatch(setCarouselVehicleCode(eventKey));
};

export const renderCarouselItems = (vehicle, isPrimaryImageView, profile, viewAngle, getCompareImages, removeVehicle, isLocked,
                                    comingSoonIMG, isLoadingState, isMobile, isMobileHeight,swapTriggered, t) => {
    const mediaItems = Object.values(vehicle.media[Object.keys(vehicle.media)[0]]);
    const filteredVehicle =
         mediaItems.filter((profileView) =>
            profileView.code === profile &&
            profileView.imageType === viewAngle &&
            profileView.url !== '')

    return mediaItems.length > 0 && mediaItems.map((media) => (
        <Carousel.Item key={media.url}>
                <button
                    type="button"
                    className={"close-compare"}
                    id={"photos-vehicle-remove"}
                    onClick={() => removeVehicle(vehicle, 1)}
                    disabled={checkLockStatus(vehicle, isLocked, 1)}
                    title={
                        checkLockStatus(vehicle, isLocked, 1)
                            ? t("overview.changeSelectModal.vehicleLocked")
                            : null
                    }
                >
                    <CloseIcon fontSize={"medium"} />
                </button>

            <div className={'photo-section'} data-testid={media?.imageType}>
                {isLoadingState ? (
                        <div className="competitor-loader-container">
                            <Loader isMobile={isMobile || isMobileHeight} isSwappedClicked={swapTriggered}/>
                        </div>) :
                    <>
                        <img
                            src={isPrimaryImageView
                                ? (filteredVehicle.length > 0 ? filteredVehicle[0]?.url : comingSoonIMG)
                                : (media?.url || comingSoonIMG)}
                            className={"compare-slider-photo"}
                            alt={media?.url || "image-not-available"}
                        />

                        {!isMobile &&
                        <div className="powertrain-icon" style={{ bottom: 30, right: "25%"}}>
                            <PowerTrainType powertrain={vehicle?.powertrain}/>
                        </div>
                        }
                    </>


                }
            </div>
        </Carousel.Item>
    ));
};

